import { z } from 'zod'
import { addressEditItemSchema } from '@/shared/schemas/addressEditSchema'
import { LICENSE_TYPES } from './createOrganizationSchema'

/**
 * Schema para edición de organización. Los campos escalares son opcionales en la
 * mutation (`PortalUpdateOrganization` acepta partial updates) y el form sólo
 * envía los que cambiaron (lo decide el llamador). Las direcciones se validan
 * estrictamente (mismas reglas que negocio): al menos una dirección activa.
 */
export const updateOrganizationSchema = z
  .object({
    legalName: z.string().trim().min(3, 'Mínimo 3 caracteres').max(80, 'Máximo 80 caracteres'),
    propietaryName: z.string().trim().min(2, 'Indica el nombre del propietario').max(160),
    description: z.string().trim().max(500, 'Máximo 500 caracteres').optional().or(z.literal('')),
    logo: z.string().trim().max(500).optional().or(z.literal('')),
    licenseType: z.enum(LICENSE_TYPES, { message: 'Selecciona el tipo de facturación' }),
    plannedDayToPay: z
      .number({ message: 'Indica un día válido' })
      .int()
      .min(1, 'Mínimo 1')
      .max(28, 'Máximo 28')
      .optional()
      .nullable(),
    addresses: z.array(addressEditItemSchema),
  })
  .superRefine((val, ctx) => {
    const active = val.addresses.filter((a) => !a._deleted)
    if (active.length === 0) {
      ctx.addIssue({
        code: 'custom',
        path: ['addresses'],
        message: 'La organización debe tener al menos una dirección',
      })
    }
  })

export type UpdateOrganizationFormValues = z.infer<typeof updateOrganizationSchema>
